import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Flex, H1, H2, Text, Button } from "ui-components";
import isNil from "lodash/isNil";
import get from "lodash/get";
import { gotoUrl } from "utils/helpers";
import { COLORS } from "ui-components/theme";

const pageHeaderProps = {
  alignSelf: "self-start",
  flexDirection: "column"
};

const PageHeader = props => {
  const {
    title,
    subtitle,
    section_title,
    padding,
    paddingBottom,
    style = {}
  } = props;

  if (!isNil(padding)) {
    pageHeaderProps["padding"] = padding;
  } else {
    pageHeaderProps["paddingBottom"] = paddingBottom || [4, 5];
  }

  return (
    <Flex {...pageHeaderProps} style={style}>
      {title && <PageTitle {...props} />}
      {subtitle && <PageSubtitle {...props} />}
      {section_title && <PageSectionTitle {...props} />}
    </Flex>
  );
};

const PageTitle = props => {
  const {
    title,
    changeButton,
    themeColors,
    title_color,
    title_bg_color,
    title_highlight_color,
    padding_left,
    center,
    titleStyles
  } = props;
  const changeUrl = get(changeButton, "url", "");
  const changeUrlPreserve = get(changeButton, "preserve", false);
  const changeLabel = get(changeButton, "label", "change");
  const highlightColor =
    title_highlight_color || get(themeColors, "secondary", COLORS.blue[4]);
  const buttonColor = get(themeColors, "primary", COLORS.blue[4]);
  let titleStyle = titleStyles || {};
  if (title_bg_color) {
    titleStyle = {
      backgroundColor: title_bg_color,
      borderRadius: "0 2.5rem 2.5rem 0",
      padding: "0.5rem 2rem"
    };
    if (padding_left) {
      titleStyle["marginLeft"] = "-" + padding_left;
      titleStyle["paddingLeft"] = padding_left;
    }
  }
  if (title_color) {
    titleStyle["color"] = title_color;
  }
  var centerStyle = center
    ? { display: "flex", margin: "auto", maxWidth: 300 }
    : {};

  return (
    <Flex
      justifyContent="space-between"
      mb={2}
      sx={{
        ".page-title > span > span ": { color: `${highlightColor} !important` }
      }}
    >
      <H1
        mb={1}
        className="page-title"
        style={{ ...titleStyle, ...centerStyle }}
      >
        <FormattedMessage html id={title} values={props} />
      </H1>
      {changeUrl && (
        <Button
          as={"a"}
          variant="closeButton"
          sx={{ fontSize: "1rem", color: buttonColor }}
          onClick={() => {
            gotoUrl(changeUrl, changeUrlPreserve);
          }}
        >
          <FormattedMessage id={changeLabel} />
        </Button>
      )}
    </Flex>
  );
};

const PageSubtitle = props => {
  const { subtitle } = props;

  return (
    <Text size="sm" mb={1}>
      <FormattedMessage html id={subtitle} values={props} />
    </Text>
  );
};

const PageSectionTitle = props => {
  const { section_title } = props;

  return (
    <H2>
      <FormattedMessage html id={section_title} values={props} />
    </H2>
  );
};

PageHeader.defaultProps = {
  title: "",
  subtitle: "",
  section_title: ""
};

export default PageHeader;
